import axios from 'axios'
import dayjs from "dayjs";
import { useFormik } from 'formik'
import moment from "moment";
import { enqueueSnackbar } from "notistack";
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import * as yup from 'yup'
import { API } from "../../../helpers/constants";
import { handleAxiosErrors } from "../../../helpers/errorHandling";
import { getRouteUrl } from '../../../helpers/routing/getRouteUrl'
import useUserData from "../../../hooks/user/useUserData";
import { PROJECTS } from "../locales/namespaces";
import { ROUTE_PAGE_PROJECT_DETAILS } from "../routes/routes";

const useProjectForm = ({ projectId, project, assignees, projectWorks }) => {
	
	const history = useHistory()
	const { t } = useTranslation(PROJECTS)
	const [loadingSubmit, setLoadingSubmit] = useState(false)
	const { token, dateFormat } = useUserData()
	
	const onSubmit = (values) => {
		setLoadingSubmit(true)
		axios({
			method: 'post',
			data: {
				isActive: values.isActive,
				Description: values.Description,
				// UserId: values.AssigneeId.id,
				StartDt: dayjs(values.StartDt).format('YYYY-MM-DD'),
				EndDt: dayjs(values.EndDt).format('YYYY-MM-DD'),
				// EstimDt: dayjs(values.EstimDt).format('YYYY-MM-DD'),
				EstimCost: values.EstimCost,
				
			},
			headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
			url: !projectId ? `${API}/en/fts/project/store` : `${API}/en/fts/project/update/` + projectId
		}).then(response => {
			setLoadingSubmit(false)
			enqueueSnackbar(t(`Project ${!projectId ? 'created' : 'updated'} successfully!`), {
				variant: 'success',
				autoHideDuration: 3000,
			});
			history.push(getRouteUrl(ROUTE_PAGE_PROJECT_DETAILS, { projectId: !projectId ? response.data.id : projectId }))
			
		}).catch((error) => {
			setLoadingSubmit(false)
			enqueueSnackbar(handleAxiosErrors(error, t('An error occurred!')), {
				variant: 'warning',
				autoHideDuration: 3000,
			})
		})
	}
	
	const validationSchema = yup.object().shape({
		Description: yup.string().required(t('Required')),
		StartDt: yup
		.date()
		.typeError(t('Invalid date'))
		.required(t('Required'))
		.test('is-before-end', t('Start date must be before the end date.'), function (value) {
			const { EndDt } = this.parent
			if (!value || !EndDt) return true
			return new Date(value) <= new Date(EndDt)
		}),
		EndDt: yup
		.date()
		.typeError(t('Invalid date'))
	});
	
	const formik = useFormik({
		initialValues: {
			isActive: projectId ? project?.isActive : true,
			Description: project?.Description || '',
			// AssigneeId: project?.AssigneeId || {},
			// AssigneeName: project?.AssigneeName || '',
			StartDt: projectId ? dayjs(project?.StartDt) : dayjs(),
			EndDt: projectId ? dayjs(project?.EndDt) : dayjs(),
			// EstimDt:  projectId? dayjs(project?.EstimDt): dayjs(),
			EstimCost: project?.EstimCost || '',
		},
		validationSchema: validationSchema,
		onSubmit: onSubmit,
	})
	
	return {
		formik,
		loadingSubmit
	}
	
}
export default useProjectForm